import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import ProductDetailComponent from "../../Components/ProductDetailComponent/ProductDetailComponent";
import {
  Apiurl,
  parseData,
  stringifyData,
  GetLocalStorageParsed,
  SetLocalStorageStringify,
  secretKey,
} from "../utils/page";
import axios from "axios";
import { toast } from "react-toastify";
import LoginModal from "../../Components/LoginModal/LoginModal";
import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import Loader from "../../Components/Loader/Loader";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";

const ProductDetail = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showLoginTrue, setShowLoginTrue] = useState();
  const [DeliveryAddressList, setDeliveryAddressList] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);

  const handleShow = () => {
    setShowLoginModal(true);
  };
  const handleClose = () => {
    setShowLoginModal(false);
  };

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [productDetail, setProductDetail] = useState();
  const [checkCartStatus, setCheckCartUpdateStatus] = useState(false);
  const [checkCartOrder, setCheckCartOrderStatus] = useState(false);
  const [bidAmountValue, setBidAmountValue] = useState();
  const [valueOfBid, setValueofbid] = useState("");
  const [bidUpdate, setBidUpdate] = useState(false);
  const [loading, setLoading] = useState("");
  const [profileChange, setProfileChange] = useState(false);
  const [showProductImage, setShowProductImage] = useState();

  const [Address, setAddress] = useState({
    name: "",
    mobile: "",
    pincode: "",
    address: "",
    locality: "",
    city: "",
    state: "",
    landmark: "",
    altPhone: "",
  });

  const [productsByVendor, setProductsByVendor] = useState();
  // get product by id
  const handleGetProductsByVendorId = (item) => {
    const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    // const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);
    const data = {
      id: item,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/FetchProductsByVendorId`,
    };
    axios(option)
      .then((e) => {
        const data=parseData(e?.data?.result)
        const filteredProducts = data?.filter(
          (product) =>
            !(product.Id == originalId || product.IsWinnerDeclare == true)
        );
        setProductsByVendor(filteredProducts);
      })
      .catch((error) => {});
  };
  // get product by id
  const handleGetProduct = (item) => {
    setLoading("getPro");
 
    const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    // const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);

    const data = {
      productId: originalId,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${item || loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/GetById`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setProductDetail(data);
        const imagesArray = JSON.parse(data.Images);

        const defaultImage = imagesArray?.find((img) => img.Default);

        const imageUrl = defaultImage
          ? `${Apiurl()}/${defaultImage.Images}`
          : "";
          setShowProductImage(imageUrl)
        setBidAmountValue(data?.UserPlacedBidAmount);
        setValueofbid(data?.UserPlacedBidAmount);
        handleGetProductsByVendorId(data?.VendorId);
        setLoading("");
      })
      .catch((error) => {});
  };
  // login api
  const loginApi = (userDetail) => {
    const data = {};
    data.email = userDetail?.email;
    data.name = userDetail?.name;
    data.image = userDetail?.picture;
    const options = {
      method: "POST",
      headers: {
        accept: "*/*",

        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Customer/Login`,
    };
    axios(options)
      .then((data) => {
        const token = parseData(data?.data?.result);
        const user = jwtDecode(token?.Token);

        SetLocalStorageStringify("UserDetail", JSON.stringify(token));
        SetLocalStorageStringify("User", JSON.stringify(user));
        SetLocalStorageStringify("AuthToken", token?.Token);
        SetLocalStorageStringify("googleImage", userDetail?.picture);
        setLoginToken(token?.Token);
        setShowLoginTrue(token?.Token);
        handleClose();
        handleGetProduct(token?.Token);
      })
      .catch((error) => {});
  };
  const handleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      const userInfo = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        { headers: { Authorization: `Bearer ${access_token}` } }
      );

      loginApi(userInfo?.data);
      // SetLocalStorageStringify("googleData", userInfo?.data)
    },
  });
  const getDeliveryAddress = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Customer/FetchDeliveryAddressList`,
    };
    axios(option)
      .then((e) => {
        setDeliveryAddressList(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0); 
    handleGetProduct();
  }, [location.pathname]);
  useEffect(() => {
    getDeliveryAddress();
  }, []);

  // add bid
  const handleAddBid = () => {
    if (loginToken) {
      if (!valueOfBid) {
        toast.error("Please enter Bid Amount");
        return;
      }
      if (valueOfBid == 0) {
        toast.error("Bid should greater than 0");
        return;
      }
      if (valueOfBid < productDetail?.RecommendedBid) {
        toast.error("Bid should not be less than recommended bid");
        return;
      }
      if (!DeliveryAddressList?.length) {
        setShowAddressModal(true);
        return;
      }
      setLoading("addBid");
      const data = {
        ProductId: `${productDetail?.Id}`,
        BidAmount: valueOfBid,
      };
      const option = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${loginToken || " "}`,
        },
        data: stringifyData(data),
        url: `${Apiurl()}/api/Cart/AddBid`,
      };
      axios(option)
        .then((e) => {
          if (e?.data?.status === "BadRequest") {
            setLoading("");

            toast.error(e?.data?.message);
          } else {
            setLoading("");
            setProfileChange(true);
            setBidUpdate(true);
            handleGetProduct();
            handleAddToCartBid();

            toast.success(e?.data?.message);
          }

          // handleCartItems(token)
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      handleShow();
    }
  };
  //   add to cart
  const handleAddToCart = () => {
    if (loginToken) {
      if (!DeliveryAddressList?.length) {
        setShowAddressModal(true);
        return;
      }
      setLoading("addBid");

      const data = {
        productId: productDetail?.Id,
        Quantity: "1",
      };
      const option = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${loginToken || " "}`,
        },
        data: stringifyData(data),
        url: `${Apiurl()}/api/order/add`,
      };
      axios(option)
        .then((e) => {
          setLoading("");

          setCheckCartOrderStatus(true);
          handleGetProduct();
          if (e?.data?.message === "Update successfully") {
            toast.error("Item already in cart");
          } else {
            toast.success("Item added to cart");
          }

          if (e?.data?.status === "BadRequest") {
            toast.error(e?.data?.message);
          }

          // handleCartItems(token)
        })
        .catch((error) => {
          setLoading("");
        });
    } else {
      handleShow();
    }
  };
  const handleAddToCartBid = () => {
    const data = {
      productId: productDetail?.Id,
      date: new Date(),
      qty: 1,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Cart/Add`,
    };
    axios(option)
      .then((e) => {
        setCheckCartUpdateStatus(true);
        // if (e?.data?.status === "OK") {
        //   toast.success(e?.data?.message);
        // }
        // if (e?.data?.status === "BadRequest") {
        //   toast.error(e?.data?.message);
        // }
      })
      .catch((error) => {});
  };

  const handleCloseAddress = () => {
    setShowAddressModal(false);
  };
  const validateAddress = () => {
    if (!Address.mobile) {
      toast.error("Mobile number is required");
      return false;
    }
    if (!Address.pincode) {
      toast.error("Pincode is required");
      return false;
    }
    if (!Address.address) {
      toast.error("Address is required");
      return false;
    }
    if (!Address.locality) {
      toast.error("Locality is required");
      return false;
    }
    if (!Address.city) {
      toast.error("City is required");
      return false;
    }
    if (!Address.state) {
      toast.error("State is required");
      return false;
    }
    return true;
  };
  const handleAddAddress = () => {
    if (!validateAddress()) return;
    const data = {};

    data.phoneNumber = Address.mobile;
    data.pincode = Address.pincode;
    data.locality = Address.locality;
    data.areaAndStreet = Address.address;
    data.city = Address.city;
    data.state = Address.state;
    data.landmark = Address.landmark;
    data.altPhoneNumber = Address.altPhone;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/AddUpdateDeliveryAddress`,
    };

    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          getDeliveryAddress();
          setShowAddressModal(false);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {loading === "getPro" ? 
      <div className="loading-container">
      <Loader />
    </div>
      : null}
      <Header
        setBidUpdate={setBidUpdate}
        profileChange={profileChange}
        bidUpdate={bidUpdate}
        setCheckCartOrderStatus={setCheckCartOrderStatus}
        setCheckCartUpdateStatus={setCheckCartUpdateStatus}
        checkCartStatus={checkCartStatus}
        checkCartOrder={checkCartOrder}
        setLoginToken={setLoginToken}
        setLoading={setLoading}
        setProfileChange={setProfileChange}
        showLoginTrue={showLoginTrue}
      />
      <ProductDetailComponent
        productDetail={productDetail}
        productsByVendor={productsByVendor}
        handleAddBid={handleAddBid}
        handleAddToCart={handleAddToCart}
        setBidAmountValue={setBidAmountValue}
        setValueofbid={setValueofbid}
        valueOfBid={valueOfBid}
        setLoading={setLoading}
        loading={loading}
        bidAmountValue={bidAmountValue}
        handleGetProduct={handleGetProduct}
        DeliveryAddressList={DeliveryAddressList}
        showAddressModal={showAddressModal}
        handleCloseAddress={handleCloseAddress}
        setAddress={setAddress}
        Address={Address}
        handleAddAddress={handleAddAddress}
        setShowProductImage={setShowProductImage}
        showProductImage={showProductImage}
      />
      <LoginModal
        showLoginModal={showLoginModal}
        setShowLoginModal={setShowLoginModal}
        handleClose={handleClose}
        handleLogin={handleLogin}
      />

      <Footer />
    </div>
  );
};

export default ProductDetail;
